import React from 'react'
import { Paper } from '@material-ui/core'

function PanelError(props) {

    function TAS_STATIC_IMAGE(filename) {
        const TAS_STATIC_IMAGE_DIR = `${process.env.PUBLIC_URL}/static/images/tas/`
        return (TAS_STATIC_IMAGE_DIR + filename)
    }

    //* return JSX -------------------------------------------------------------
    return (
        //* Start JSX ----------------------------------------------------------

        <Paper className="error">
            <img src={TAS_STATIC_IMAGE("right_panel_error.svg")} />
            <label>Error retrieving data</label>
            <span>Please try again or contact system administrator.</span>
        </Paper>

        //* End JSX ------------------------------------------------------------
    );

    //* End of function --------------------------------------------------------
}

export default PanelError